import {RsnDialog, RsnSpinner} from '@raison/ui-kit';
import React from 'react';

export function CommonLoaderDialog({reason}: {reason: string}) {
    return (
        <RsnDialog.Window placement='center'>
            <div className='flex flex-col items-center gap-2 px-4 py-6'>
                <div>
                    <RsnSpinner color='neutral100' h={24} w={24} />
                </div>
                <div>{reason}</div>
            </div>
        </RsnDialog.Window>
    );
}
